import React from "react";
import { SoftButton } from "../UI/DesignStandards";

const messageFor = (catalog) => {
  if (!catalog) return "";
  if (catalog.kind === "disagrees") {
    return `Catalog has ${catalog.average}${
      catalog.games != null ? ` (${catalog.games} games)` : ""
    } from ${catalog.source}.`;
  }
  if (catalog.kind === "possibleMatch") {
    return `Sheet has ${catalog.extractedName}. Confirm this is the same person${
      catalog.average != null ? ` before using ${catalog.average}` : ""
    }.`;
  }
  if (catalog.kind === "noQualifyingAverage") {
    return catalog.reason || "No catalog average meets the minimum games.";
  }
  if (catalog.kind === "usbcConflict") {
    return "Catalog USBC does not match the USBC already on this bowler.";
  }
  if (catalog.kind === "autoVerified") {
    return `Verified from ${catalog.source}.`;
  }
  return "";
};

const CatalogAverageNotice = ({
  bowler,
  canManage,
  verifying,
  onUseCatalogAverage,
}) => {
  const catalog = bowler.catalog;
  if (!catalog || bowler.isVerified) {
    if (catalog?.kind === "autoVerified") {
      return (
        <p className="text-xs text-brand-muted mt-1">{messageFor(catalog)}</p>
      );
    }
    return null;
  }
  if (
    ![
      "disagrees",
      "possibleMatch",
      "noQualifyingAverage",
      "usbcConflict",
    ].includes(catalog.kind)
  ) {
    return null;
  }

  return (
    <div className="mt-2 space-y-2 max-w-md">
      <p className="text-xs text-brand-charcoal">{messageFor(catalog)}</p>
      {canManage && catalog.average != null ? (
        <SoftButton
          color="gold"
          size="xs"
          onClick={() => onUseCatalogAverage(bowler.bowlerId)}
          disabled={verifying}
        >
          {verifying ? "Saving" : "Use catalog average"}
        </SoftButton>
      ) : null}
    </div>
  );
};

export default CatalogAverageNotice;
